import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../common/widgets/Button';
import Dialog from '../../../../../common/widgets/Dialog';
import Icons from '../../../../../common/widgets/Icons';
import { resources } from '../../../resources/resources';

interface NoPaymentMethodsDialogProps {
  closeDialog: () => void;
}

export const NoPaymentMethodsDialog = (props: NoPaymentMethodsDialogProps) => {
  const { closeDialog } = props;
  const { t: translate } = useTranslation();
  return (
    <Dialog
      closeDialog={closeDialog}
      showCloseIcon
      closeOnClickOutside
      className="dialog-m error-dialog"
    >
      <div className="dialog-title">
        {_.unescape(translate(resources.products.noPaymentMethodsDialog.title))}
      </div>
      <div className="dialog-content">
        <h3 className="d-error-title">
          <Icons.DialogCreditCard />
          {translate(resources.paymentOrCoPayment)}
        </h3>
        <p className="d-error-text">
          {translate(
            resources.products.noPaymentMethodsDialog.paymentOrCoPayment,
          )}
        </p>

        <h3 className="d-error-title">
          <Icons.DialogFunds />
          {translate(resources.benefitsBudget)}
        </h3>
        <p className="d-error-text">
          {translate(resources.products.noPaymentMethodsDialog.benefitsBudget)}
        </p>

        <h3 className="d-error-title">
          <Icons.DialogEdenredCards />
          {translate(resources.edenredCards)}
        </h3>
        <p className="d-error-text">
          {translate(resources.marketingCards.edenredCards.title)}
        </p>

        <h3 className="d-error-tip-title">
          <Icons.DialogBenefitTip />
          {translate(resources.benefitTip)}
        </h3>
        <p className="d-error-tip-text">
          {translate(resources.products.noPaymentMethodsDialog.tip)}
        </p>
      </div>
      <div className="dialog-actions">
        <Button onClick={closeDialog} className="btn btn-outline">
          {translate(resources.understood)}
        </Button>
      </div>
    </Dialog>
  );
};
